import React, { useState, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { SettingsContextProvider } from "./store/settings";
import { ThemeProvider } from '@mui/material/styles';
import { WidgetContextProvider } from "./store/widgetContext";
import { DefaultTheme } from "./theme";
import ApplicationRoutes from "./routes";
import "./App.css";

export default function App() {
	const [tenantId, setTenantId] = useState(null);
	const [botId, setBotId] = useState(null);
	const [assistantId, setAssistantId] = useState(null);
	const [UUID, setUUID] = useState(null);
	const [lang, setLang] = useState(null);
	const [sandbox, setSandbox] = useState(false);

	// Read query params from iframe URL once on mount
	useEffect(() => {
		const params = new URLSearchParams(window.location.search);
		const tenantId = params.get("tenantId");
		const botId = params.get("botId");
		// D-R21 (refinement 2026-10-02): OPTIONAL — the channel binds its agent server-side (the bootstrap
		// answers `primaryAssistantId`). The loader forwards it only from a legacy `data-assistant-id`
		// snippet; the pre-D-R21 loader sent the literal "null" when absent, which is absent too.
		const rawAssistantId = params.get("assistantId");
		const assistantId = rawAssistantId && rawAssistantId !== "null" ? rawAssistantId : null;
		const uuid = params.get("uuid");
		const isSandbox = params.get("sandbox");
		const contact_language = params.get("contact_language") || navigator.language || "en";
		if (tenantId && botId && uuid) {
			setTenantId(tenantId);
			setBotId(botId);
			setAssistantId(assistantId);
			setUUID(uuid);
			setLang(contact_language);
			setSandbox(isSandbox === "true");
		} else {
			console.warn("[App] Missing required query parameters!");
		}
	}, []);

	return (
		<>
			{tenantId && botId && UUID && lang ? (
				<WidgetContextProvider>
					<ThemeProvider theme={DefaultTheme}>
						<SettingsContextProvider>
							<BrowserRouter>
								<ApplicationRoutes
									tenantId={tenantId}
									botId={botId}
									assistantId={assistantId}
									projectUUID={UUID}
									uuid={UUID}
									lang={lang}
									sandbox={sandbox}
								/>
							</BrowserRouter>
						</SettingsContextProvider>
					</ThemeProvider>
				</WidgetContextProvider>
			) : (
				<div
					style={{
						height: "100vh",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
						color: "#aaa",
						fontSize: "18px",
					}}
				>
          			Loading widget...
				</div>
			)}
		</>
	);
}
